<template>
  <div>
    <!-- GRAFIK CABANG -->
    <div class="mt-3 mx-3">
      <v-card class="pa-3 rounded-lg" :style="{
        backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg-lhp)' : 'var(--light-bg-lhp)',
      }">
        <v-row>
          <v-col cols="12">
            <div class="pa-3">
              <span class="text-subtitle-2 font-weight-bold align-center"> Grafik Cabang </span>
            </div>
          </v-col>
        </v-row>
        <v-divider class="mx-3" />

        <!-- Tambahkan div untuk scroll horizontal -->
        <div class="chart-container mx-3">
          <div class="chart-wrapper">
            <div v-if="loading" class="d-flex justify-center align-center" style="height: 300px;">
              <v-progress-circular indeterminate color="primary" size="40" />
            </div>
            <canvas v-else ref="chartCanvas"></canvas>
          </div>
        </div>
      </v-card>
    </div>
    <!-- END GRAFIK CABANG -->
  </div>
</template>

<script>
import Chart from "chart.js";
import services from "@/services"; // Pastikan ini mengarah ke service API yang benar

export default {
  props: {
    chartType: {
      type: String,
      default: "bar",
    },
  },
  data() {
    return {
      loading: true,
      chartInstance: null, // Simpan instance chart
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Target",
            backgroundColor: "#e76f51",
            data: [],
          },
          {
            label: "Menagih",
            backgroundColor: "#520e63",
            data: [],
          },
          {
            label: "Tertagih",
            backgroundColor: "#27445D",
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                fontSize: 8,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 8,
                callback: function (value) {
                  return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0
                  }).format(value);
                },
              },
            },
          ],
        },
        tooltips: {
          bodyFontSize: 8,
          titleFontSize: 8,
          callbacks: {
            label: function (tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label || "";
              const value = tooltipItem.yLabel;
              const formatted = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0
              }).format(value);
              return `${label}: ${formatted}`;
            },
          },
        },
        legend: {
          labels: {
            fontSize: 8,
          },
        },
      },
    };
  },
  async mounted() {
    await this.fetchChartData();
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
  },
  methods: {
    async fetchChartData() {
      this.loading = true;
      try {
        const response = await services.grafikCabang();

        if (response.data && response.data.status && response.data.data) {
          const targetData = response.data.data.target || [];
          const menagihData = response.data.data.menagih || [];
          const tertagihData = response.data.data.tertagih || [];

          if (!Array.isArray(targetData) || !Array.isArray(menagihData) || !Array.isArray(tertagihData)) {
            console.warn("Data API tidak dalam format array.");
            return;
          }

          const labels = targetData.map((item) => String(item.branch_name));
          const targetValues = targetData.map((item) => Number(item.nominal) || 0);
          const menagihValues = menagihData.map((item) => Number(item.nominal) || 0);
          const tertagihValues = tertagihData.map((item) => Number(item.nominal) || 0);

          // Perbarui chartData dengan data API
          this.chartData.labels = labels;
          this.chartData.datasets[0].data = targetValues;
          this.chartData.datasets[1].data = menagihValues;
          this.chartData.datasets[2].data = tertagihValues;

          this.loading = false;

          this.$nextTick(() => {
            this.renderChart();
          });
        } else {
          console.error("Status API false atau format data tidak sesuai:", response.data);
          this.loading = false;
        }
      } catch (error) {
        console.error("Gagal mengambil data:", error);
        this.loading = false;
      }
    },
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const canvas = this.$refs.chartCanvas;
      if (!canvas) {
        // console.warn("Canvas not found");
        return;
      }
      const ctx = canvas.getContext("2d");

      this.chartInstance = new Chart(ctx, {
        type: this.chartType,
        data: this.chartData,
        options: this.chartOptions,
      });
    },
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>
<style scoped>
.chart-container {
  overflow-x: auto;
}

.chart-wrapper {
  min-width: 800px;
  height: 300px;
}
</style>
